<template>
    <div class="col-lg-9">
        <h2 class="font-weight-400 mb-3">Corporate Wallets</h2>

        <!-- Filter ============================================= -->
        <div class="row">
            <div class="col mb-2">
                <form @submit.prevent="data.fetch()" method="post">
                    <div class="form-row">
                        <!-- Date Range
                        ========================= -->
                        <div class="col-sm-3 col-md-2 form-group">
                            <select @change="data.fetch()" v-model="data.filters.size" class="custom-select"
                                    required="">
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="col-sm-6 col-md-5 form-group">
                            <input type="text" class="form-control" v-model="data.filters.search"
                                   placeholder="Search...">
                            <span class="icon-inside"><i class="fas fa-search"></i></span>
                        </div>
                        <div class="col-auto d-flex align-items-center ml-auto form-group">
                            <router-link to="/business/wallets/deposit"
                                         v-if="hasPermission(permissions, 'input-transactions')"
                                    class="btn btn-primary btn-sm text-white px-3 shadow-none mr-3">
                                <i class="fas fa-arrow-down"></i> Fund Wallet
                            </router-link>
                            <button @click.prevent="data.fetch()"
                                    class="btn btn-primary btn-sm text-white px-3 shadow-none"
                                    :class="[ data.loading ? 'btn-loading' : '']">
                                <i class="fas fa-search"></i> Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- Filter End -->

        <div class="bg-light shadow-sm rounded p-4 mb-4">
            <h3 class="text-5 font-weight-400 mb-4">
                All Wallets
                <span class="text-muted text-3">(for payments and payouts)</span>
            </h3>
            <div class="row">
                <div v-for="(wallet, index) in data.content.data" class="col-12 col-sm-6 col-lg-4 mb-4">
                    <router-link
                        :to="`/business/wallet/${wallet.id}/view`"
                        :class="wallet.type === 'Corporate' ? 'account-card-primary' : ''"
                        class="d-block account-card text-white rounded p-3 mb-4 mb-lg-0"
                    >
                        <small class="text-uppercase font-weight-700">{{ wallet.type }}</small>
                        <p class="text-4 text-uppercase mt-n2 mb-1">
                            {{ wallet.currency }} Wallet
                        </p>
                        <p class="d-flex align-items-center mb-1">
                                        <span class="account-card-expire border-left text-uppercase d-inline-block opacity-6 mr-2">
                                            Active<br />Since<br />
                                        </span>
                            <span class="text-1 opacity-9">
                                        {{ new Date(wallet.created_at).toLocaleDateString() }}
                                        </span>
                            <span
                                class="bg-light text-0 text-body font-weight-500 rounded-pill d-inline-block px-2 line-height-4 opacity-8 ml-auto"
                            >
                                            {{ wallet.status }}
                                        </span>
                        </p>
                        <p class="d-flex align-items-center m-0">
                                    <span class="text-uppercase text-4 font-weight-500">
                                        {{ wallet.currency }} {{ money(wallet.balance) }}
                                    </span>
                            <i class="fas fa-wallet ml-auto"></i>
                        </p>
                    </router-link>
                </div>
            </div>
            <hr class="mx-n3">
            <div class="d-flex align-items-center justify-content-between">
                <span class="text-black-50">
                    Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                </span>
                <ul class="pagination justify-content-center mt-4 mb-0">
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-left"></i>
                        </a>
                    </li>
                    <li class="page-item active">
                        <a @click="data.append()"
                           v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                           class="page-link" href="#">
                            Load More <span class="sr-only">(current)</span>
                        </a>
                    </li>
                    <li class="page-item d-flex align-content-center flex-wrap text-muted text-5 mx-1">
                        <span>...</span>
                    </li>
                    <li class="page-item disabled">
                        <a class="page-link" href="#" tabindex="-1">
                            <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Data from "../../../core/data/Data";
import {money} from "../../../core/forms/money";

export default {
    name: "Index",
    metaInfo: {
        title: "Corporate Wallets"
    },
    mixins: [money],
    props:['permissions'],
    data() {
        return {
            corporate: window.user.corporate,
            data: new Data({
                url: "/business/wallets/list",
                prefix: "list"
            })
        };
    },
    mounted() {
        this.data.fetch()
    }
}
</script>

<style scoped>
.account-card.account-card-biller {
    background: -webkit-linear-gradient(135deg, #9acd32, #ff4500);
    background: -moz-linear-gradient(135deg, #9acd32, #ff4500);
    background: -o-linear-gradient(135deg, #9acd32, #ff4500);
    background: -ms-linear-gradient(135deg, #9acd32, #ff4500);
    background: linear-gradient(-45deg, #9acd32, #ff4500);
}
</style>
